import React from 'react';

export default class CKEditor extends React.Component {
  textareaRef = React.createRef();
  
  editor = null;

  componentDidMount() {
    this.createEditor();
  }

  componentDidUpdate(prevProps) {
    if (
      this.editor &&
      this.props.data !== prevProps.data &&
      this.props.data !== this.editor.getData()
    ) {
      this.editor.setData(this.props.data);
    }
  }

  componentWillUnmount() {
    this.destroyEditor();
  }

  createEditor() {
    const { config = {}, initData } = this.props;

    this.editor = CKEDITOR.replace(this.textareaRef.current, { ...CKEDITOR.config, ...config });

    if (initData !== undefined) {
      this.editor.setData(initData);
    }
    this.bindEditorEvents();
  }

  bindEditorEvents() {
    const events = ['change', 'instanceReady'];

    events.forEach((eventName) => {
      const handler = this.props[`on${eventName[0].toUpperCase()}${eventName.slice(1)}`];

      if (handler) {
        this.editor.on(eventName, (event) => {
          handler({
            event,
            editor: this.editor,
            data: this.editor.getData(),
          });
        });
      }
    });
  }

  destroyEditor() {
    if (this.editor) {
      this.editor.destroy();
      this.editor = null;
    }
  }

  render() {
    return <textarea ref={this.textareaRef} />;
  }
}
